import { Badge } from 'framework/ui/mui-builder';
import { useFieldHelper } from 'framework/ui/field';
import { UpcomingChangeStatus } from './constants';
import { BadgeLayoutProps } from 'framework/ui/uiContract';

interface UpcomingChangesBadgeProps {
  source: string;
  value: UpcomingChangeStatus;
}

const STATUS_CONFIG: Record<UpcomingChangeStatus, { label: string; backgroundColor: BadgeLayoutProps['color'] }> = {
  [UpcomingChangeStatus.ASSIGNED]: { label: 'Assigned', backgroundColor: 'success' },
  [UpcomingChangeStatus.PENDING]: { label: 'Pending', backgroundColor: 'warning' },
};

const UpcomingChangesBadge = ({ source, value }: UpcomingChangesBadgeProps) => {
  const { getValue } = useFieldHelper({ source });
  const statusValue = value || getValue();

  const config = STATUS_CONFIG[statusValue as keyof typeof STATUS_CONFIG];
  const { label, backgroundColor } = config || {
    label: 'Unknown',
    backgroundColor: 'default',
  };

  return (
    <Badge color={backgroundColor} sx={{ '.MuiChip-label': { overflow: 'visible' } }}>
      {label}
    </Badge>
  );
};

export default UpcomingChangesBadge;
